import { readable, writable, get } from "svelte/store"


export const saveStatus = writable({
    options: false,
    storeItems: false,
    place: false,
})

export const editStatus = writable({
    options: false,
    storeItems: false,
    place: false,
})


